export const API_ADDRESS = '/api/';

export const UPLOAD_MAX_SIZE = 10485760;
export const FEE_STRUCTURE_ITEMS = 6;
